import React from "react";
import { withStyles } from "material-ui/styles";
import classnames from "classnames";

const styles = {};

const CTableRow = props => {
  const { children, classes, className, ...otherProps } = props;

  return (
    <tr {...otherProps} className={classnames(className)}>
      {children}
    </tr>
  );
};

export default withStyles(styles)(CTableRow);



// WEBPACK FOOTER //
// ./src/uis/CTable/CTableRow.jsx